// $(document).ready(function () {
//     console.log("noti-timer.js loaded");
//     console.log('$("#noti-end-date")[0].value', $("#noti-end-date")[0].value);
//     if($("#noti-end-date")[0].value){
//         // let countDownDate = new Date($("#noti-end-date")[0].value).getTime();
//         // let countDownDate = new Date($("#noti-end-date").attr('value')).getTime();
//         let countDownDate = Number($("#noti-end-date").attr('value').trim()) * 1000;
//         // debugger;
//         // console.log("countDownDate", countDownDate, new Date($("#noti-end-date").attr('value')), $("#noti-end-date").attr('value'))
//         // debugger;

//         if(countDownDate){
//             let x = setInterval(function(){
//                 let now = new Date().getTime();
//                 let distance = countDownDate - now;
//                 console.log("now", now)
//                 console.log("distance", distance)
    
//                 var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//                 var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//                 var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//                 var seconds = Math.floor((distance % (1000 * 60)) / 1000);

//                 // console.log("TIMES: ", now, distance, days, hours, minutes, seconds)
                
//                 if(days === 0){
//                     $("#noti-timer").text( hours + "h " + minutes + "m " + seconds + "s ");

//                 }else{
//                     $("#noti-timer").text(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");
//                 }
    
//                 // If the count down is finished, write some text
//                 if (distance < 0) {
//                     clearInterval(x);
//                     $("#noti-timer").text("EXPIRED");
//                 }
    
//             }, 1000)
    
//         }
//     }
// })

addEventListener("DOMContentLoaded", function() {
    console.log("noti-timer.js loaded");
    console.log('$("#noti-end-date")[0].value', $("#noti-end-date")[0].value);
    if($("#noti-end-date")[0].value){
        // let countDownDate = new Date($("#noti-end-date")[0].value).getTime();
        // let countDownDate = new Date($("#noti-end-date").attr('value')).getTime();
        let countDownDate = Number($("#noti-end-date").attr('value').trim()) * 1000;
        // debugger;
        // console.log("countDownDate", countDownDate, new Date($("#noti-end-date").attr('value')), $("#noti-end-date").attr('value'))
        // debugger;

        if(countDownDate){
            let x = setInterval(function(){
                let now = new Date().getTime();
                let distance = countDownDate - now;
                console.log("now", now)
                console.log("distance", distance)
    
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // console.log("TIMES: ", now, distance, days, hours, minutes, seconds)
                
                if(days === 0){
                    $("#noti-timer").text( hours + "h " + minutes + "m " + seconds + "s ");

                }else{
                    $("#noti-timer").text(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");
                }
    
                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    $("#noti-timer").text("EXPIRED");
                }
    
            }, 1000)
    
        }
    }
});